import React, { useEffect, useLayoutEffect, useState } from "react";
import Button from "@mui/material/Button";
import { Divider, GridLegacy } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import { AxiosRequest, getOptionsForUser, ImgURL, XMLrequest } from "../../Url";
import { NestedMenuItem } from "./NestedMenuOrigin/NestedMenuItem";

import { tokenProcessingTest } from "../../TokenProcessing/TokenProcessing";

import { extend, isEmptyObject } from "./Tools";
import { useAtom } from "jotai";
import { workPlaceToolsAtom } from "../../../atoms";

// eslint-disable-next-line
const SectionToolsJS = (props) => {
  const [menuBarSection, setMenuBarSection] = useState([]);
  const [buttonsSection, setButtonsSection] = useState([]);
  const [workSpaceTools, setWorkSpaceTools] = useAtom(workPlaceToolsAtom);
  const [dataButtonsDefault, setDataButtonsDefault] = useState();
  const [open1, setOpen1] = useState(false);
  const [menuBarDefault, setMenuBarDefault] = useState(undefined);
  const [ID, setID] = useState();
  const [AssMass, setAssMass] = useState(new Map());
  const [anchorElAss, setAnchorElAss] = useState(new Map());
  const [subForms, setSubForms] = useState(undefined);
  const [display, setDisplay] = useState("flex");

  useLayoutEffect(() => {
    getWorkPlaceTools();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (subForms !== undefined) {
      setTimeout(() => {
        tokenProcessingTest(subForms);
      }, 10);
    }
  }, [subForms]);

  const handleClick = (event) => {
    setOpen1(!open1);
    const id = event.currentTarget.getAttribute("id");
    setAssMass(AssMass.set(id, true));
    setAnchorElAss(anchorElAss.set(id, event.currentTarget));
    setID(id);
  };

  const handleClose = (event) => {
    setOpen1(!open1);
    // const id = event.currentTarget.getAttribute("id");
    setAssMass(AssMass.set(ID, false));
    setAnchorElAss(anchorElAss.set(ID, null));
  };

  const handleClickItemMenu = (event) => {
    setOpen1(!open1);
    // const id = event.currentTarget.getAttribute("id");
    const Path = event.currentTarget.getAttribute("path");
    const Token = event.currentTarget.getAttribute("token");
    const Params = event.currentTarget.getAttribute("params");
    const Module = event.currentTarget.getAttribute("module");
    // const Type = event.currentTarget.getAttribute("type");
    setAssMass(AssMass.set(ID, false));
    setAnchorElAss(anchorElAss.set(ID, null));
    if (Path !== null) {
      handeleExecToolprogram(event);
    } else if (Token === "SelectObject") {
      let ObjType = getObjType(Params);
      let CLSID = getCLSID(Params);
      GetSelectObject(ObjType, CLSID);
      //GetDialogParam(ObjType)
    } else if (Token) {
      let params = new Map();
      params.set("prefix", Module);
      params.set("comand", Token);
      params.set("WSM", "1");
      AxiosRequest(true, params).then((res) => {
        tokenProcessingTest(res, { propsId: props.ID });
      });
    }

    //setDid(<DialogContainer title={id} contentText={JSXInfoAboutClickedItem} />)
  };

  function getObjType(str) {
    let pos = str.indexOf("ObjType=") + 8;
    return str.substring(pos, str.indexOf(",", pos));
  }

  function getCLSID(str) {
    let pos = str.indexOf("CLSID=") + 6;
    return str.substring(pos, str.indexOf(",", pos));
  }

  const GetSectionTools = async () => {
    let params = new Map(),
      json;
    params.set("prefix", "tools");
    params.set("comand", "GetSectionTools");
    params.set("SectionID", props.ID);
    json = await AxiosRequest(true, params);
    if (isEmptyObject(json)) {
      setMenuBarSection([]);
    } else {
      if (json["Buttons"]) setButtonsSection(json["Buttons"]);
      if (json) setMenuBarSection(json["MenuBar"]);
    }
  };

  const getWorkPlaceTools = async () => {
    let json = {};

    if (workSpaceTools === undefined) {
      let params = new Map();
      params.set("prefix", "config");
      params.set("comand", "GetWorkPlaceTools");
      json = await AxiosRequest(true, params);
      setWorkSpaceTools(json);
    } else {
      json = Object.assign({}, workSpaceTools);
    }

    if (json === undefined && isEmptyObject(json) && getOptionsForUser()?.authed_by !== undefined) {
      DisableBar();
    } else {
      if (json["Buttons"]) setDataButtonsDefault(json["Buttons"]["Button"]);
      if (json["MenuBar"]) {
        setMenuBarDefault(json["MenuBar"]);
        CreateMap(json["MenuBar"]);
        GetSectionTools();
      } else {
        if (props.setHeight) props.setHeight("95%");
        if (props.setLoad) props.setLoad(true);
        GetSectionTools();
        // DisableBar();
      }
    }
  };

  function DisableBar() {
    setDisplay("none");
    if (props.setHeight) {
      props.setHeight("100%");
    }
  }

  const GetSelectObject = (ObjType, CLSID) => {
    let param = new Map(),
      json;
    param.set("prefix", "ABLUtils");
    param.set("comand", "SelectObject");
    param.set("CLSID", CLSID);
    param.set("ObjType", ObjType);
    param.set("OnlyView", "1");
    param.set("WSM", "1");
    json = XMLrequest(param);
    setSubForms(json);
  };

  function CreateMap(List) {
    for (const key of Object.keys(List)) {
      setAnchorElAss(anchorElAss.set(key, null));
      setAssMass(AssMass.set(key, false));
    }
  }

  function RecItems(jsonItems, CurrentID) {
    if (jsonItems !== undefined) {
      let DeepFirst, Token, Params, Module, openSet, Path, Image;
      let assemblyLists = [];

      for (const [key, value] of Object.entries(jsonItems)) {
        Token = jsonItems[key]["Token"];
        Path = jsonItems[key]["Path"];
        Image = jsonItems[key]["Image"];
        Params = jsonItems[key]["Params"];
        Module = jsonItems[key]["Module"];
        DeepFirst = value;

        // ArrItems = Object.keys(DeepFirst);

        if (Token !== undefined || Path !== undefined) {
          //это то что будет внутри item
          let prS = Image === undefined ? 0.5 : 0.2;
          let Type = jsonItems[key]["Type"];
          assemblyLists.push(
            <GridLegacy key={key}>
              <MenuItem
                token={Token}
                params={Params}
                path={Path}
                type={Type}
                module={Module}
                id={key}
                onClick={handleClickItemMenu}
                style={{ height: "32px", marginLeft: 2 }}
              >
                <GridLegacy sx={{ pr: prS, pt: 0.5 }}>
                  {Image === undefined ? (
                    <div style={{ paddingLeft: "13px" }}></div>
                  ) : (
                    ImgURL(Image, { width: "16px", height: "16px" })
                  )}
                </GridLegacy>
                {key}
              </MenuItem>
            </GridLegacy>,
          );
        } else if (typeof DeepFirst === "object" && Object.keys(DeepFirst).length > 0) {
          // это item который будет распахиваться
          openSet = AssMass.get(CurrentID);
          if (key !== "Image" && key !== "-") {
            assemblyLists.push(
              <GridLegacy key={key}>
                <NestedMenuItem
                  style={{
                    paddingLeft: "10px",
                    height: "32px",
                    marginLeft: 3,
                  }}
                  leftIcon={
                    Image === undefined ? (
                      <div style={{ paddingLeft: "16px" }}></div>
                    ) : (
                      ImgURL(Image, {
                        height: "16px",
                        width: "16px",
                        marginLeft: 7,
                        marginTop: 3,
                        marginRight: -5,
                      })
                    )
                  }
                  label={key}
                  parentMenuOpen={openSet}
                >
                  {RecItems(DeepFirst, CurrentID)}
                </NestedMenuItem>
              </GridLegacy>,
            );
          }
        }
      }
      return assemblyLists;
    }
  }

  function Rec(jsonItems, jsonItemsSection) {
    if (jsonItems !== undefined && jsonItemsSection !== undefined) {
      // (jsonItems)
      let DeepFirst,
        // ArrItems,
        openSet = false,
        anchorElset,
        Token;
      let assemblyLists = [];
      //CreateMap(jsonItems)
      let assignedButtons = {};
      assignedButtons = extend(true, jsonItems, jsonItemsSection);
      for (const [key, value] of Object.entries(assignedButtons)) {
        Token = value["Token"];
        DeepFirst = value;
        // ArrItems = Object.keys(DeepFirst);
        // (key + "----------------------------------")

        if (Token === undefined) {
          //это то что будет внутри item
          openSet = AssMass.get(key);
          anchorElset = anchorElAss.get(key);

          assemblyLists.push(
            <GridLegacy item key={key}>
              <Button id={key} onClick={handleClick} style={{ textTransform: "none", height: "25px" }}>
                {key}
              </Button>
              <Menu
                id={key}
                anchorEl={anchorElset}
                open={openSet ? true : false}
                onClose={handleClose}
                sx={{
                  boxShadow:
                    "rgba(0, 0, 0, 0.2) 0px 5px 1px -3px, rgba(0, 0, 0, 0.14) 0px 8px 30px 1px, rgba(0, 0, 0, 0.12) 0px 3px 30px 2px",
                }}
              >
                {RecItems(DeepFirst, key)}
                {/* {RecItems(jsonItemsSection[key], key)} */}
              </Menu>
            </GridLegacy>,
          );
        }
      }
      return assemblyLists;
    }
  }

  async function handeleExecToolprogram(event, type) {
    ///tools~ExecToolProgram
    let Path = event.currentTarget.getAttribute("path"),
      Type,
      params = new Map();
    if (Path === "SetupProjectParams") {
      params.set("prefix", "config");
      params.set("comand", "SetupProjectParams");
      params.set("WSM", "1");
      AxiosRequest(true, params).then((res) => {
        tokenProcessingTest(res, { propsId: props.ID });
      });
      return;
    }
    Type = event.currentTarget.getAttribute("type");
    params.set("prefix", "tools");
    params.set("comand", "ExecToolProgram");
    params.set("Path", encodeURIComponent(Path));
    params.set("Type", Type);
    params.set("Checked", "0");
    params.set("WSM", "1");
    AxiosRequest(true, params, props.postData).then((res) => {
      tokenProcessingTest(res, { propsId: props.ID });
    });
  }

  const RenderButtons = (ButtonsLocal, WichButton) => {
    let newKey = 0;
    if (ButtonsLocal !== undefined && WichButton === "SectionTools") {
      let items = [],
        Path,
        Module,
        Type;

      items.push(
        <GridLegacy key={"default-button-section-tools" + 0} item>
          {props.defaultButton}
        </GridLegacy>,
      );
      for (const [key, value] of Object.entries(ButtonsLocal)) {
        Path = backValue(value, "Path");
        Type = backValue(value, "Type");
        Module = backValue(value, "Module");
        items.push(
          <GridLegacy key={key} item toolsbutton="">
            <Tooltip title={key} arrow>
              <IconButton
                path={Path}
                type={Type}
                module={Module}
                color="primary"
                component="span"
                onClick={handeleExecToolprogram}
              >
                {ImgURL(backValue(value, "Image"))}
              </IconButton>
            </Tooltip>
          </GridLegacy>,
        );
      }
      return items;
    } else if (ButtonsLocal !== undefined && WichButton === "WorkPlace") {
      let items = [],
        Token,
        Hint;
      Hint = ButtonsLocal.Hint;
      Token = ButtonsLocal.Token;
      items.push(
        <GridLegacy key={`button-${newKey}`} item toolsbutton="">
          <Tooltip title={Hint} arrow>
            <IconButton
              path={Token}
              // module={value.Module}
              color="primary"
              component="span"
              onClick={(e) => handeleExecToolprogram(e)}
            >
              {ImgURL(ButtonsLocal.Image)}
            </IconButton>
          </Tooltip>
        </GridLegacy>,
      );
      newKey++;
      return items;
    }
  };

  const backValue = (value, param) => {
    return value[param];
  };

  return (
    <GridLegacy
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      sx={{ pl: 1 }}
      id={"tools" + props.ID}
      style={{ flex: "0 1 auto", display: display, borderBottom: "1px solid #d8c2c2" }}
    >
      <GridLegacy item>
        <GridLegacy
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          id={"buttons_for_section" + props.ID}
        ></GridLegacy>
      </GridLegacy>
      <GridLegacy item>
        <GridLegacy container direction="row" justifyContent="flex-start" alignItems="center">
          {RenderButtons(dataButtonsDefault, "WorkPlace")}
          <Divider orientation="vertical" flexItem />
          {RenderButtons(buttonsSection, "SectionTools")}
          <Divider orientation="vertical" flexItem />
          {Rec(menuBarDefault, menuBarSection)}
        </GridLegacy>
      </GridLegacy>

      <GridLegacy id="RenderDefault"></GridLegacy>
    </GridLegacy>
  );
};

export default SectionToolsJS;
